import { useEffect, useState } from 'react'
import { CardContent } from '@mui/material'
import { toastHelper } from '../../util/toastHelper'
import { VendorPublicProfileV2 } from '../../components/profileCards/VendorV2'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { updateProfile } from '../../features/authSlice'
import { getImageFilesValidationError } from '../../util/imageUploadValidation'
// TODO: editing profile doesnt work AT ALL when claiming

export const VendorProfile = ({ data }) => {
    const dispatch = useDispatch()
	const { userId } = useParams()
    const curUserId = useSelector((s) => s.auth?.user?._id)

    const sameUser = userId === curUserId

	const [formData, setFormData] = useState({
        imageMediaMap: {},
        images: [],
		media: [],
		instagramLink: '',
		tiktokLink: '',
		facebookLink: '',
        websiteLink: '',
		services: [],
	})

	const handleFileChange = (e, type) => {
		if (type === 2) {
			const files = Array.from(e.target.files || [])
			if (!files.length) return

			const validationError = getImageFilesValidationError(files)
			if (validationError) {
				return toastHelper(validationError, 'error')
			}

			const maxPhotos = 100
			setFormData((prev) => {
				let nextMedia = [...prev.media]
				let nextMap = { ...prev.imageMediaMap }
				for (const file of files) {
					if (nextMedia.length >= maxPhotos) break
					const fileURL = URL.createObjectURL(file)
					nextMedia.push(fileURL)
					nextMap[fileURL] = file
				}
				return {
					...prev,
					containsImage: 'media',
					media: nextMedia,
					imageMediaMap: nextMap,
				}
			})
			return
		}

		const file = e.target.files[0]
        if (!file) return

		const validationError = getImageFilesValidationError([file])
		if (validationError) {
			return toastHelper(validationError, 'error')
		}
        const fileURL = URL.createObjectURL(file)

		if (type === 0) {
			// business profile picture
			dispatch(
				updateProfile({
					containsImage: 'businessProfilePic',
					imageMediaMap: { [fileURL]: file },
				})
			)
		} else if (type === 1) {
			// background cover picture
			dispatch(
				updateProfile({
					containsImage: 'coverPic',
					imageMediaMap: { [fileURL]: file },
				})
			)
		}
	}

	useEffect(() => {
		setFormData({
            businessAddress: data.businessAddress,
			businessName: data.businessName,
			media: data.media,
			businessTypes: data.businessTypes,
			numEmployees: data.numEmployees,
			instagramLink: data.instagramLink,
			tiktokLink: data.tiktokLink,
			facebookLink: data.facebookLink,
            websiteLink: data.websiteLink,
			services: data.services,
            businessDescription: data.businessDescription,
            // pics
			businessProfilePic: data.businessProfilePic,
			coverPic: data.coverPic,
            topVendor: data.topVendor,
			// if venue
			maxCapacity: data.maxCapacity,
            // images
            imageMediaMap: {},
            images: [],
			customBusinessType: data.customBusinessType ?? "",
            // vendor profile completed (for vendors that see their own public profile)
            profileCompleted: data?.profileCompleted
		})
	}, [data])

	return (
		<div
			style={{
				position: 'relative',
			}}
		>
            <VendorPublicProfileV2
                formData={formData}
                handleFileChange={handleFileChange}
                setFormData={setFormData}
                editable={sameUser}
                canEditBusinessDetails={sameUser && data?.__t === 'vendor'}
                vendorId={data._id}
                reviewsData={data.reviews}
                sameUser={sameUser}
                showBackButton={!sameUser}
            />
		</div>
	)
}
